(function () {
  'use strict';

  angular
    .module('directive.responsive-img', [])

    /* @ngInject */
    .directive('responsiveImg', function () {
      return {
        restrict: 'A',
        priority: 100,
        scope: {
          sizes: '='
        },
        link: function (scope, element, attrs) {

          var deregister = attrs.$observe('responsiveImg', function (size) {

            var src = '/Image/' + scope.sizes.id + '/' + scope.sizes[size];
            if (angular.isDefined(attrs.lazyImg)) {
              if (element.hasClass('loaded')) {
                element.attr('src', src);
              } else {
                attrs.$set('lazyImg', src);
              }
            } else {
              element.attr('src', src);
            }
          });

          scope.$on('$destroy', deregister);

        }
      };

    });

})();
